// src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import RegisterForm from './components/RegisterForm';
import LoginForm from './components/LoginForm';
import RecuperarPassword from './components/auth/RecuperarPassword';
import ActualizarPassword from './components/auth/ActualizarPassword';
import ModernLanding from './components/home/ModernLanding';
import GoogleAnalytics from './lib/GoogleAnalytics';
import Clarity from './lib/Clarity';
import Products from './components/Products';
import BuyProduct from './components/BuyProduct';
import Participa from './components/Participa';
import Carrito from './components/Carrito';
import MyAccount from './components/MyAccount';
import MisReferidos from './components/MisReferidos';
import CarritoIcono from './components/CarritoIcono';
import { CarritoProvider } from './components/context/CarritoContext.js';
import { PuntosProvider } from './components/context/PuntosContext';
import MisPuntos from './components/MisPuntos.js';
import MisPedidos from './components/MisPedidos.js';
import Sorteo from './components/Sorteo.js';
import ComoParticipar from './components/ComoParticipar.js';
import ComprarTickets from './components/ComprarTickets.js';
import MenuAdmin from './components/admin/MenuAdmin';
import VentasAdmin from './components/admin/VentasAdmin';
import AdminDashboard from './components/admin/AdminDashboard';
import ScrollToTop from './components/common/ScrollToTop';
import TerminosYCondiciones from './components/legal/TerminosYCondiciones';
import ElMontoncito from './components/game/ElMontoncito';
import { loginUser, getCurrentUser } from './services/auth';
import CreateFolders from './components/task/CreateFolders.js';
import PoliticasPrivacidad from './components/legal/PoliticasPrivacidad';

function App() {
  const [userData, setUserData] = useState(null);
  const [totalPuntos, setTotalPuntos] = useState(0);

  useEffect(() => {
    // Cargar usuario autenticado actual si existe
    const initAuth = async () => {
      try {
        const user = await getCurrentUser();
        if (user) {
          setUserData(user);
        }
      } catch (err) {
        console.warn('Error al verificar sesión inicial:', err);
      }
    };
    initAuth();
  }, []);

  const handleLogin = async (credentials) => {
    try {
      const user = await loginUser(credentials);
      setUserData(user);
    } catch (error) {
      console.error('Error de inicio de sesión:', error);
    }
  };

  const actualizarPuntos = (nuevoPuntaje) => {
    setTotalPuntos(nuevoPuntaje);
  };

  return (
    <PuntosProvider>
      <CarritoProvider>
        <div className="App bg-[#0c0f14] min-h-screen text-gray-100 flex flex-col justify-between">
          <Router basename={process.env.PUBLIC_URL}>
            <ScrollToTop />
            <Header />
            <CarritoIcono />
            <MenuAdmin />
            <div className="flex-grow">
              <Routes>
                <Route path="/" element={<ModernLanding />} />

                {/* Autenticación y Recuperación de Contraseña */}
                <Route path="/registrate" element={<RegisterForm />} />
                <Route path="/ingresar" element={<LoginForm onLogin={handleLogin} />} />
                <Route path="/recuperar-contrasena" element={<RecuperarPassword />} />
                <Route path="/actualizar-contrasena" element={<ActualizarPassword />} />

                {/* Catálogo y Productos */}
                <Route path="/productos" element={<Products />} />
                <Route path="/productos/detalle-producto/:sku/comprar" element={<BuyProduct />} />
                <Route path="/productos/detalle-producto/:sku/participa" element={<Participa />} />
                <Route path="/productos/detalle-producto/:sku/sorteo/:key" element={<Sorteo />} />

                {/* Carrito y Cuenta */}
                <Route 
                  path="/carrito" 
                  element={<Carrito onCarritoVacio={() => console.log('El carrito está vacío')} />} 
                />
                <Route path="/mis-datos" element={<MyAccount />} />
                <Route path="/mis-referidos" element={<MisReferidos />} />
                <Route path="/mis-puntos" element={<MisPuntos />} />
                <Route path="/mis-pedidos" element={<MisPedidos />} />

                {/* Información y Dinámicas */}
                <Route path="/como-participar" element={<ComoParticipar />} />
                <Route path="/comprar-tickets" element={<ComprarTickets />} />

                {/* Administración */}
                <Route path="/admin" element={<AdminDashboard initialTab="dashboard" />} />
                <Route path="/admin/usuarios" element={<AdminDashboard initialTab="usuarios" />} />
                <Route path="/admin/productos" element={<AdminDashboard initialTab="productos" />} />
                <Route path="/admin/tablas" element={<AdminDashboard initialTab="tablas" />} />
                <Route path="/admin/ventas" element={<AdminDashboard initialTab="ventas" />} />

                {/* Legal */}
                <Route path="/legal/terminos-y-condiciones" element={<TerminosYCondiciones />} />
                <Route path="/legal/politica-de-privacidad" element={<PoliticasPrivacidad />} />
                <Route path="/task/create-folders" element={<CreateFolders />} />

                {/* Juego El Montoncito */}
                <Route 
                  path="/juegos/el-montoncito" 
                  element={
                    <ElMontoncito 
                      userData={userData} 
                      totalPuntos={totalPuntos} 
                      actualizarPuntos={actualizarPuntos}
                    />
                  } 
                />
              </Routes>
            </div>
            <Footer />
          </Router>
          <GoogleAnalytics />
          <Clarity />
        </div>
      </CarritoProvider>
    </PuntosProvider>
  );
}

export default App;